import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './auth/AuthProvider';
import { AuthCallback } from './auth/AuthCallback';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { UsersList } from './pages/UsersList';
import { UserDetail } from './pages/UserDetail';
import { RunsList } from './pages/RunsList';
import { RunDetail } from './pages/RunDetail';
import { FindingsList } from './pages/FindingsList';
import { FindingDetail } from './pages/FindingDetail';
import { TriageSessionsList } from './pages/TriageSessionsList';
import { TriageSessionDetail } from './pages/TriageSessionDetail';
import { AuditLog } from './pages/AuditLog';
import { Settings } from './pages/Settings';
import { UnknownAtsHosts } from './pages/UnknownAtsHosts';
import { Waitlist } from './pages/Waitlist';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

export function App(): React.ReactElement {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route element={<Layout />}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/users" element={<UsersList />} />
              <Route path="/users/:id" element={<UserDetail />} />
              <Route path="/runs" element={<RunsList />} />
              <Route path="/runs/:id" element={<RunDetail />} />
              <Route path="/findings" element={<FindingsList />} />
              <Route path="/findings/:status/:id" element={<FindingDetail />} />
              <Route path="/triage-sessions" element={<TriageSessionsList />} />
              <Route path="/triage-sessions/:id" element={<TriageSessionDetail />} />
              <Route path="/audit" element={<AuditLog />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/improvements/unknown-ats" element={<UnknownAtsHosts />} />
              <Route path="/waitlist" element={<Waitlist />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
